// Shared presentation helpers for the complaints pages: source / severity / status labels, plus
// two small pure helpers (days-open and overdue). The status and severity PILLS are the registry's
// (design system Session 7a): <StatusPill domain="complaint" ...> and domain="complaintSeverity".
import type { ComplaintSource, ComplaintSeverity, ComplaintStatus } from "../../lib/api";

export const SOURCE_LABEL: Record<ComplaintSource, string> = {
  customer: "Customer",
  third_party: "Third party",
  internal: "Internal",
  regulatory: "Regulatory",
};

export const SEVERITY_LABEL: Record<ComplaintSeverity, string> = {
  low: "Low",
  medium: "Medium",
  high: "High",
  critical: "Critical",
};

export const STATUS_LABEL: Record<ComplaintStatus, string> = {
  open: "Open",
  investigating: "Investigating",
  resolved: "Resolved",
  closed: "Closed",
};

// Whole days from `fromIso` to `toIso` (or now), floored at 0. Used for "days open".
export function daysBetween(fromIso: string, toIso?: string | null): number {
  const from = new Date(fromIso).getTime();
  const to = toIso ? new Date(toIso).getTime() : Date.now();
  if (Number.isNaN(from) || Number.isNaN(to)) return 0;
  return Math.max(0, Math.floor((to - from) / (24 * 60 * 60 * 1000)));
}

// A complaint is "overdue" when open/investigating and past its target resolution date.
export function isComplaintOverdue(c: { status: ComplaintStatus; targetResolutionDate: string | null }): boolean {
  if (c.status !== "open" && c.status !== "investigating") return false;
  if (!c.targetResolutionDate) return false;
  const t = new Date(c.targetResolutionDate).getTime();
  return !Number.isNaN(t) && t < Date.now();
}

export const COMPLAINT_CATEGORIES = ["Service quality", "Response time", "Engineer conduct", "Billing", "LOLER", "Other"] as const;
